// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"08b40409","491":"152061ec","660":"ce4fb345","757":"4e2aeda8","774":"570b6fc5","883":"f4664431"}[chunkId] + ".chunk.js";
};